import { render } from "./CreateNewAnswerModal.vue?vue&type=template&id=79c6dab8&scoped=true"
import script from "./CreateNewAnswerModal.vue?vue&type=script&lang=js"
export * from "./CreateNewAnswerModal.vue?vue&type=script&lang=js"

import "./CreateNewAnswerModal.vue?vue&type=style&index=0&id=79c6dab8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c6dab8"]])

export default __exports__